// @flow

import React, { Component } from 'react';
import { countWorkItems } from '../actions';
import { Page,  StampCard, Dimmer } from "tabler-react";
import { SiteWrapper } from "../common";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import Auth from '../auth/auth';

const auth = new Auth({});

class DashboardPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      newItems: {
        current: 0,
        total: 0,
        loading: false
      },
      completedToday: {
        current: 0,
        total: 0,
        loading: false
      },
      newMentions: {
        current: 0,
        total: 0,
        loading: false
      }
    };
  }

  isAdmin() {
    return auth.hasAccess('request', 'admin');
  }

  componentDidMount() {

    this.setState({
      newItems: { loading: true },
      completedToday: { loading: true },
      newMentions: { loading: true }
    });

    this.props.countWorkItems('New', (response) => {
      console.log('countWorkItems', 'New', response);
      let { current, total } = response.data;
      this.setState({ newItems: { current, total, loading: false } });
    }, (error) => {
      console.log('countWorkItems', 'New', error);
      this.setState({ newItems: { loading: true } });
    });

    this.props.countWorkItems('Completed', (response) => {
      console.log('countWorkItems', 'Completed', response);
      let { current, total } = response.data;
      this.setState({ completedToday: { current, total, loading: false } });
    }, (error) => {
      console.log('countWorkItems', 'Completed', error);
      this.setState({ completedToday: { loading: true } });
    });

    this.props.countWorkItems('Mentions', (response) => {
      console.log('countWorkItems', 'Mentions', response);
      let { current, total } = response.data;
      this.setState({ newMentions: { current, total, loading: false } });
    }, (error) => {
      console.log('countWorkItems', 'Mentions', error);
      this.setState({ newMentions: { loading: true } });
    });

  }

  render() {

    const { newItems, completedToday, newMentions } = this.state;

    return (
      <SiteWrapper>
        <Page.Content title="Dashboard">
            <div className="row">
                <div className="col-sm-4">
                  <Dimmer active={newItems.loading} loader>
                    <StampCard color="blue" icon="activity"
                     header={
                       <NavLink to={`/requisition/${this.isAdmin() ? 'all' : 'assigned'}`}>
                         {newItems.current} <small>New Items</small>
                       </NavLink>
                     }
                     footer={`${newItems.total} total items`}
                   />
                  </Dimmer>
                </div>
                <div className="col-sm-4">
                  <Dimmer active={completedToday.loading} loader>
                    <StampCard color="green" icon="check"
                     header={
                       <NavLink to={`/requisition/${this.isAdmin() ? 'all' : 'assigned'}`}>
                         {completedToday.current} <small>Completed Today</small>
                       </NavLink>
                     }
                     footer={`${completedToday.total} total completed`}
                   />
                  </Dimmer>
                </div>
                <div className="col-sm-4">
                  <Dimmer active={newMentions.loading} loader>
                    <StampCard color="yellow" icon="message-square"
                     header={
                       <a>
                         {newMentions.current} <small>New Mentions</small>
                       </a>
                     }
                     footer={`${newMentions.total} unread mentions`}
                   />
                  </Dimmer>
                </div>
            </div>
        </Page.Content>
      </SiteWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    countWorkItems
  }, dispatch);
}

function mapStateToProps(props) {
  return props;
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage)



// WEBPACK FOOTER //
// ./src/dashboard/dashboard.react.js